import { Outlet } from "react-router-dom";
import Mynavbar from "../components/students/Mynavbar/Mynavbar";
import Footer from "../components/students/Footer/Footer";

const StudentMainLayout = () => {
  return (
    <>
      <Mynavbar />
      <Outlet />   {/* ✅ Ye bahut important hai */}
      <Footer />
    </>
  );
};

export default StudentMainLayout;
